import i18n from '@/i18n'

export default class EnumService {
    getEnum(values, id) {
        var result = values.filter(obj => {
            return obj.Id === id;
        });
        return result[0];
    }
    getEnumName(values, id) {
        var result = values.filter(obj => {
            return obj.Id === id;
        });
        return (result[0] != null) ? result[0].Name : null;
    }
    getEnumId(values, name) {
        var result = values.filter(obj => {
            return obj.Name === name;
        });
        return (result[0] != null) ? result[0].Id : null;
    }
    getRoleEnum() {
        return [
            { Name: i18n.t('Goalkeeper'), Id: 1 },
            { Name: i18n.t('CentralDefenderRight'), Id: 2 },
            { Name: i18n.t('CentralDefenderLeft'), Id: 3 },
            { Name: i18n.t('RightBack'), Id: 4 },
            { Name: i18n.t('LeftBack'), Id: 5 },
            { Name: i18n.t('RightWinger'), Id: 6 },
            { Name: i18n.t('LeftWinger'), Id: 7 },
            { Name: i18n.t('DefensiveMidfielder'), Id: 8 },
            { Name: i18n.t('AttackingMidfielder'), Id: 9 },
            { Name: i18n.t('SecondStriker'), Id: 10 },
            { Name: i18n.t('CentreForward'), Id: 11 }
        ];
    }
    getRoleEnumWithAllRoles() {
        return [
            { Name: i18n.t('AllRoles'), Id: 0 },
            { Name: i18n.t('Goalkeeper'), Id: 1 },
            { Name: i18n.t('CentralDefenderRight'), Id: 2 },
            { Name: i18n.t('CentralDefenderLeft'), Id: 3 },
            { Name: i18n.t('RightBack'), Id: 4 },
            { Name: i18n.t('LeftBack'), Id: 5 },
            { Name: i18n.t('RightWinger'), Id: 6 },
            { Name: i18n.t('LeftWinger'), Id: 7 },
            { Name: i18n.t('DefensiveMidfielder'), Id: 8 },
            { Name: i18n.t('AttackingMidfielder'), Id: 9 },
            { Name: i18n.t('SecondStriker'), Id: 10 },
            { Name: i18n.t('CentreForward'), Id: 11 }
        ];
    }
    getContractStatusEnum() {
        return [
            { Name: i18n.t('Unattached'), Id: 0 },
            { Name: i18n.t('Bound'), Id: 1 }
        ];
    }
    getFootEnum() {
        return [
            { Name: i18n.t('FootRight'), Id: 0 },
            { Name: i18n.t('FootLeft'), Id: 1 },
            { Name: i18n.t('FootBoth'), Id: 2 }
        ];
    }
    getRefundRangeEnum() {
        return [
            { Name: "0 - 500 €", Id: 0 },
            { Name: "500 - 1000 €", Id: 1 },
            { Name: "1000 - 2000 €", Id: 2 },
            { Name: "2000 - 5000 €", Id: 3 },
            { Name: "> 5000 €", Id: 4 }
        ];
    }
    getRefundMaxRangeValueEnum() {
        return [
            { Name: "500", Id: 0 },
            { Name: "1000", Id: 1 },
            { Name: "2000", Id: 2 },
            { Name: "5000", Id: 3 },
            { Name: "5000", Id: 4 }
        ];
    }
    getSkillsEvaluatorRoleEnum() {
        return [
            { Name: i18n.t('SportsDirector'), Id: 0 },
            { Name: i18n.t('Directive1'), Id: 1 },
            { Name: i18n.t('Coach'), Id: 2 },
            { Name: i18n.t('Scout'), Id: 3 },
            { Name: i18n.t('Player'), Id: 4 }
        ];
    }
    getCategoryEnum() {
        return [
            { Name: "Serie A", Id: 0 },
            { Name: "Serie B", Id: 1 },
            { Name: "Serie C", Id: 2 },
            { Name: "Primavera 1", Id: 3 },
            { Name: "Primavera 2", Id: 4 },
            { Name: "Berretti", Id: 5 },
            { Name: "Serie D", Id: 6 },
            { Name: "Eccellenza", Id: 7 },
            { Name: "Promozione", Id: 8 },
            { Name: "Prima Categoria", Id: 9 },
            { Name: "Seconda Categoria", Id: 10 },
            { Name: "Terza Categoria", Id: 11 },
            { Name: "Juniores Elite", Id: 12 },
            { Name: "Juniores Nazionali", Id: 13 },
            { Name: "Juniores Regionali", Id: 14 },
            { Name: "Juniores Provinciali", Id: 15 },
            { Name: "Under 18 Serie A", Id: 16 },
            { Name: "Under 18 Serie B", Id: 17 },
            { Name: "Allievi Elite", Id: 18 },
            { Name: "Allievi Nazionali", Id: 19 },
            { Name: "Allievi Regionali", Id: 20 },
            { Name: "Allievi Provinciali", Id: 21 },
            { Name: "Giovanissimi Elite", Id: 22 },
            { Name: "Giovanissimi Nazionali", Id: 23 },
            { Name: "Giovanissimi Regionali", Id: 24 },
            { Name: "Giovanissimi Provinciali", Id: 25 },
            { Name: "Primi Calci / Piccoli Amici", Id: 26 },
            { Name: "Pulcini", Id: 27 },
            { Name: "Esordienti", Id: 28 }
        ];
    }
    getCategoryLevelEnum() {
        return [
            { Name: i18n.t('1stTier'), Id: 0 },
            { Name: i18n.t('2ndTier'), Id: 1 },
            { Name: i18n.t('3rdTier'), Id: 2 },
            { Name: i18n.t('4thTier'), Id: 3 },
            { Name: i18n.t('5thTier'), Id: 4 },
            { Name: i18n.t('6thTier'), Id: 5 },
            { Name: i18n.t('7thTier'), Id: 6 },
            { Name: i18n.t('8thTier'), Id: 7 },
            { Name: i18n.t('9thTier'), Id: 8 },
            { Name: i18n.t('10thTier'), Id: 9 },
            { Name: i18n.t('11thTier'), Id: 10 },
            { Name: i18n.t('12thTier'), Id: 11 },
            { Name: i18n.t('13thTier'), Id: 12 },
            { Name: i18n.t('14thTier'), Id: 13 },
            { Name: i18n.t('15thTier'), Id: 14 },
            { Name: i18n.t('YouthSection'), Id: 15 }
        ];
    }
    getAthleticProfileSkillsEnum() {
        return [
            { Name: i18n.t('Strength'), Id: 1 },
            { Name: i18n.t('Endurance'), Id: 2 },
            { Name: i18n.t('Speed'), Id: 3 },
            { Name: i18n.t('Acceleration'), Id: 4 },
            { Name: i18n.t('Rapidity'), Id: 5 },
            { Name: i18n.t('Agility'), Id: 6 },
            { Name: i18n.t('Coordination'), Id: 7 },
            { Name: i18n.t('Jumping'), Id: 8 }
        ];
    }
    getPsychologicalAspectSkillsEnum() {
        return [
            { Name: i18n.t('Leadership'), Id: 9 },
            { Name: i18n.t('Competitiveness'), Id: 10 },
            { Name: i18n.t('FairPlay'), Id: 11 },
            { Name: i18n.t('TeamSpirit'), Id: 12 },
            { Name: i18n.t('Dedication'), Id: 13 },
            { Name: i18n.t('Constancy'), Id: 14 },
            { Name: i18n.t('WorkCommitment'), Id: 15 },
            { Name: i18n.t('PersonalInitiative'), Id: 16 }
        ];
    }
    getTechnicalAspectSkillsEnum() {
        return [
            { Name: i18n.t('BallFeeling'), Id: 17 },
            { Name: i18n.t('PassingAccuracy'), Id: 18 },
            { Name: i18n.t('LongPass'), Id: 19 },
            { Name: i18n.t('Crosses'), Id: 20 },
            { Name: i18n.t('Shooting'), Id: 21 },
            { Name: i18n.t('Dribbling'), Id: 22 },
            { Name: i18n.t('BallProgression'), Id: 23 },
            { Name: i18n.t('Trapping'), Id: 24 },
            { Name: i18n.t('OrientedBallControl'), Id: 25 },
            { Name: i18n.t('Heading'), Id: 26 }
        ];
    }
    getOffensiveQualitiesSkillsEnum() {
        return [
            { Name: i18n.t('MarketLoosing'), Id: 27 },
            { Name: i18n.t('Shielding'), Id: 28 },
            { Name: i18n.t('Vision'), Id: 29 },
            { Name: i18n.t('FinishingTouch'), Id: 30 },
            { Name: i18n.t('Finishing'), Id: 31 },
            { Name: i18n.t('Creativity'), Id: 32 },
            { Name: i18n.t('PositiveTransitions'), Id: 33 }
        ];
    }
    getDefensiveQualitiesSkillsEnum() {
        return [
            { Name: i18n.t('PositioningBallRelation'), Id: 34 },
            { Name: i18n.t('1-1Situations'), Id: 35 },
            { Name: i18n.t('Marking'), Id: 36 },
            { Name: i18n.t('Anticipating'), Id: 37 },
            { Name: i18n.t('Intercepting'), Id: 38 },
            { Name: i18n.t('DefendingBox'), Id: 39 },
            { Name: i18n.t('NegativeTransitions'), Id: 40 }
        ];
    }
    getNegotiationStatusEnum() {
        return [
            { Name: i18n.t('Pending'), Id: 0 },
            { Name: i18n.t('Sent'), Id: 1 },
            { Name: i18n.t('NegotiationActive'), Id: 2 },
            { Name: i18n.t('Rejected'), Id: 3 },
            { Name: i18n.t('Trial'), Id: 4 },
            { Name: i18n.t('Signed'), Id: 5 }
        ];
    }
    getOfferStatusEnum() {
        return [
            { Name: i18n.t('Pending'), Id: 0 },
            { Name: i18n.t('Rejected'), Id: 1 },
            { Name: i18n.t('Offer.Accepted'), Id: 2 },
            { Name: i18n.t('Offer.Active'), Id: 3 },
            { Name: i18n.t('Pending'), Id: 4 },
            { Name: i18n.t('Offer.Canceled'), Id: 5 },
        ];
    }
    getOrgChartRoleEnum() {
        return [
            { Name: i18n.t('President'), Id: 0 },
            { Name: i18n.t('Coach'), Id: 1 },
            { Name: i18n.t('SportsDirector'), Id: 2 },
            { Name: i18n.t('Secretary'), Id: 3 },
            { Name: i18n.t('SettoreGiovanileResponsible'), Id: 4 },
            { Name: i18n.t('SecretarySettoreGiovanile'), Id: 5 },
            { Name: i18n.t('Directive1'), Id: 6 },
            { Name: i18n.t('Directive2'), Id: 7 },
            { Name: i18n.t('Directive3'), Id: 8 }
        ];
    }
    getRequestStatusEnum() {
        return [
            { Name: i18n.t('Active'), Id: 0 },
            { Name: i18n.t('Closed'), Id: 1 }
        ];
    }
    getRequestDeliveryStatusEnum() {
        return [
            { Name: i18n.t('Pending'), Id: 0 },
            { Name: i18n.t('Sent'), Id: 1 },
            { Name: i18n.t('Viewed'), Id: 2 },
        ];
    }
    getRequestsCandidatesStatusEnum() {
        return [
            { Name: i18n.t('Pending'), Id: 0 },
            { Name: i18n.t('Signed'), Id: 1 },
            { Name: i18n.t('Rejected'), Id: 2 },
            { Name: i18n.t('Active'), Id: 3 },
        ];
    }
    getTeamProfileEnum() {
        return [
            { Name: i18n.t('Registered'), Id: 1 },
            { Name: i18n.t('Not Registered'), Id: 5 },
            { Name: i18n.t('Not Accepted'), Id: 6 },
        ];
    }
    getCoachingStaffEnum() {
        return [
            { Name: i18n.t('CoachingStaff.Coach'), Id: 0 },
            { Name: i18n.t('CoachingStaff.MatchTrainingAnalyst'), Id: 1 },
            { Name: i18n.t('CoachingStaff.TeamManager'), Id: 2 },
            { Name: i18n.t('CoachingStaff.SportsDirector'), Id: 3 },
            { Name: i18n.t('CoachingStaff.ConditioningCoach'), Id: 4 },
            { Name: i18n.t('CoachingStaff.GeneralManager'), Id: 5 },
        ];
    }
    getCoachQualificationEnum() {
        return [
            { Name: i18n.t('CoachingStaff.UEFAPRO'), Id: 0 },
            { Name: i18n.t('CoachingStaff.UEFAA'), Id: 1 },
            { Name: i18n.t('CoachingStaff.UEFAB'), Id: 2 },
            { Name: i18n.t('CoachingStaff.UEFAGrassrootsCLicense'), Id: 3 },
            { Name: i18n.t('CoachingStaff.DLicense'), Id: 4 },
            { Name: i18n.t('CoachingStaff.GKCOACH'), Id: 5 },
            { Name: i18n.t('CoachingStaff.GKCOACHAmateurAndYouth'), Id: 6 },
        ];
    }
    getUserProfileEnum() {
        return [
            { Name: i18n.t('UserProfile.Player'), Id: 0 },
            { Name: i18n.t('UserProfile.Team'), Id: 1 },
            { Name: i18n.t('UserProfile.Agent'), Id: 2 },
            { Name: i18n.t('UserProfile.CoachingStaff'), Id: 7 },
        ];
    }
    getSeasonGoalEnum() {
        return [
            { Name: i18n.t('Offer.PlayOffGoal'), Id: 0 },
            { Name: i18n.t('Offer.LeagueWinnersGoal'), Id: 1 },
            { Name: i18n.t('Offer.PlayOutGoal'), Id: 2 }
        ];
    }
}